(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('RatingsDetailReportController', RatingsDetailReportController);

	RatingsDetailReportController.$inject = ['$window', 'WineRepository', '$log', 'lodash', '$timeout'];

	function RatingsDetailReportController($window, WineRepository, $log, lodash, $timeout){

		/* jshint validthis: true */
		var self = this;

		self.wines = [];

		self.report = {
			loading: true,
			totalBottles: 0,
			availableRatings: [],
			selectedRating: null,
			winesByRatings: [],
			totals: {}
		};

		self.currentDate = $window.moment().format('MM/DD/YYYY');

		self.currentYear = $window.moment().format('YYYY');

		self.printSettings = {
			"fontSize": 12,
			"style": "custom"
		};

		self.print = print;

		self.updateRatingType = updateRatingType;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

			self.report.availableRatings = {
				'rating.user.general': "My General Rating",
				'rating.user.point': "My 100 pt Rating",
				'rating.other.advocate': "Wine Advocate",
				'rating.other.spectator': "Wine Spectator",
				'rating.other.enthusiast': "Wine Enthusiast",
				'rating.other.vinous': "Vinous",
				'rating.other.suckling': "James Suckling"
			};


			// default to My General Rating
			if (lodash.isEmpty(self.report.selectedRating)) {
				self.report.selectedRating = 'rating.user.general';
			}

			WineRepository.all()
				.then(function(wineEntities){

					if (wineEntities.length > 0){

						self.report.tableHeaders = [
							'Wine',
							'Size',
							'Bottles',
							'Average&nbsp;Cost',
							'Value',
							'Gain&nbsp;/&nbsp;Loss'
						];

						// add only those in the cellar
						lodash.forEach(wineEntities, function(wine) {
							if (wine.cellar.qty > 0) {
								self.wines.push(wine);
							}
						});

						self.report.totalBottles = WineRepository.getTotalCellarBottleCount(wineEntities);

						_updateReport();

						return true;
					}

					return false;

				}).catch(function(err){
					$log.debug('Error getting wines', err);
				});

		}

		function _updateReport(){

			var totalWines = self.wines.length;

			var winesByRatings = lodash.groupBy(self.wines, function(w) {
				var rating = lodash.get(w, self.report.selectedRating);
				return (! lodash.isEmpty(rating)) ? rating : 'No rating';
			});


			// initialize totals
			var grandTotals = {
				bottles: self.report.totalBottles,
				value: 0,
				maturities: Object.keys(winesByRatings).length,
				wines:  totalWines
			};

			lodash.forEach(winesByRatings, function(wines, maturity) {
				// count bottles for grouping, start at 0
				var totalMaturityBottles = lodash.reduce(wines, function(total, wine) {
					return total + lodash.parseInt(wine.cellar.qty);
				}, 0);

				// total value for grouping
				var totalMaturityValue = lodash.sum(wines, function(wine) {
					var value = (wine.cellar && wine.cellar.value) ? parseFloat(wine.cellar.value) : 0;
					return (value > 0) ? value * lodash.parseInt(wine.cellar.qty) : 0;
				});
				// update grand total value
				grandTotals.value += totalMaturityValue;

				var formattedWines = [];

				lodash.forEach(wines, function(wine) {
					var varietal = (wine.varietal && wine.varietal.name) ? wine.varietal.name + ' ' : '';
					var category = (wine.category && wine.category.name) ? wine.category.name : '';
					var type = varietal + category;

					var avgPurchasePrice = wine.avgPurchasePrice();
					var avgPurchasePriceFloat = $window.numeral(avgPurchasePrice);

					var valueGainFormatted = wine.getRelativeGainPercentFormatted(avgPurchasePriceFloat);
					var valueGainClass = wine.getValueGainClass(avgPurchasePriceFloat);

					// data we want to display on a single wine
					formattedWines.push({
						name: wine.getFullName(),
						appelation: wine.getFullAppellation(),
						type: type,
						size: wine.bottleSize.name,
						qty: lodash.parseInt(wine.cellar.qty),
						avgPurchasePrice: avgPurchasePrice,
						value: $window.numeral(wine.cellar.value).format('$0,0[.]00'),
						gain: valueGainFormatted,
						gainClass: valueGainClass
					});
				});

				self.report.winesByRatings.push({
					maturity: maturity,
					bottles: totalMaturityBottles,
					value: $window.numeral(totalMaturityValue).format('$0,0[.]00'),
					wines: formattedWines
				});

			});

			self.report.totals = [
				// 'Maturity / Wine',
				'Total maturities: ' + grandTotals.maturities + '<br/>Total wines: ' + grandTotals.wines,
				// 'Size',
				null,
				// 'Bottles',
				grandTotals.bottles,
				// 'Average Cost',
				null,
				// 'Value',
				$window.numeral(grandTotals.value).format('$0,0[.]00'),
				// 'Gain / Loss'
				null
			];

			// hide loading
			self.report.loading = false;
		}

		function updateRatingType(){
			// show loading
			self.report.loading = true;
			// remove existing ratings
			self.report.winesByRatings = [];

			// let dom update to show loading
			$timeout(function() {
				// update
				_updateReport();
			});
		}

		function print(){
			return $window.print();
		}
	}

})();
